'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;
function init(_ref) {
  var el = _ref.el,
      context = _ref.context;

  var restrictedCharacters = '\xA3#/-@$%*&^()<>{}[]\\\'\u201D|'.split('');

  el.addEventListener('keydown', function (e) {
    if (restrictedCharacters.includes(e.key)) {
      e.preventDefault();
    }
  });
}